import { FilterFieldType } from 'constants/filters/filterFieldType';

export const filterFields = {
  bin: {
    label: 'Bin',
    key: 'bin',
    type: FilterFieldType.TEXT,
  },
  card_brand: {
    label: 'Card Brand',
    key: 'card_brand',
    type: FilterFieldType.TEXT,
  },
  card_type: {
    label: 'Card Type',
    key: 'card_type',
    type: FilterFieldType.TEXT,
  },
  card_sub_type: {
    label: 'Card Subtype',
    key: 'card_sub_type',
    type: FilterFieldType.TEXT,
  },
  issuing_organisation: {
    label: 'Issuing Organisation',
    key: 'issuing_organisation',
    type: FilterFieldType.TEXT,
  },
  country: {
    label: 'Country',
    key: 'country',
    type: FilterFieldType.TEXT,
  },
  iso2: {
    label: 'ISO2',
    key: 'iso2',
    type: FilterFieldType.TEXT,
  },
  iso3: {
    label: 'ISO3',
    key: 'iso3',
    type: FilterFieldType.TEXT,
  },
  iso_numeric: {
    label: 'ISO Numeric',
    key: 'iso_numeric',
    type: FilterFieldType.TEXT,
  },
};
